import {
  BRAND_NAME,
  CONTACT_POINT,
  LEGAL_NAME,
  LOGO_PATH,
  SAME_AS,
} from 'lib/constants/organization';
import type { Organization, WithContext } from 'schema-dts';
import { getBaseUrl } from 'utils/getBaseUrl';

import { orgId } from './helpers/ids';

export const buildOrganization = (): WithContext<Organization> => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': orgId(),
  name: BRAND_NAME,
  legalName: LEGAL_NAME,
  url: getBaseUrl(),
  logo: LOGO_PATH,
  sameAs: SAME_AS,
  contactPoint: {
    '@type': 'ContactPoint',
    ...CONTACT_POINT,
  },
});
